import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {PerfilRotina} from '../model/perfil/perfil-rotina.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PerfilRotinaService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/perfil-rotina`;

  salvarPerfilRotina(perfilRotina: PerfilRotina[]) {
    return this.http.post(`${this.urlBase}`, perfilRotina);
  }

  deletePerfilRotina(rotinaId: number, perfilId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.urlBase}/rotina/${rotinaId}/perfil/${perfilId}`);
  }
}
